import config from "config";

export const CONSORTIUM_FIELDS = `
inCountry {
  name
  region {
    id
    name
  }
}
city
description
lat
lng
logo
id
name
aliases
website
status
createdAt
updatedAt
verticalProfiles(where:{vertical: ${config.VERTICAL}}) {
  id
  vertical
  partnerships(where: {vertical: QUANTUM}) {
    id
    date
    description
    source
    updatedAt
    createdAt
    status
    vertical
    verticalProfiles {
      id
      entity {
        id
        name
        logo
        vertical
      }
      entityTypeProfiles {
        id
        entityType
      }
    }
  }
  entityTypeProfiles(where:{entityType: CONSORTIUM}) {
    id
    entityType
    status
    goals    
    consortiumHasMembers {
      id
      entity {
        id
        logo
        name
      }
      entityTypeProfiles {
        id
        entityType
        verticalProfiles {
          id
          entity {
            id
            name
            logo
          }
        }
      }
    }
  }
}
`;
